import { Fragment, ReactElement } from "react";
import { AnnotationContextMenu } from "./AnnotationContextMenu";
import { IAnnotation, IAnnotationPopoverData, RendererTypes } from "@bronte/viewer-api/src/main";
import { NotesPopup } from "./NotesPopup";
import { getUniqueIdForAnnotation } from "../../shared/utils";
import { AnnotationsPopover } from "./AnnotationsPopover";
import { FlashcardPopup } from "./FlashcardPopup";

interface IAnnotations {
  annotation: IAnnotation;
  setCurrentAnnotation: (annotation: IAnnotation) => void;
  onAnnotationResponse: (annotation: IAnnotation) => void;
  notesPopupDisplay: boolean;
  setNotesPopupDisplay: (visibility: boolean) => void;
  flashcardPopupDisplay: boolean;
  setFlashcardPopupDisplay: (visibility: boolean) => void;
  hideAnnotationMenu: () => void;
  showAnnotationMenu: boolean;
  annotationsPopoverData: IAnnotationPopoverData;
  hideAnnotationsPopover: () => void;
  showAnnotationsPopover: boolean;
  renderer: RendererTypes;
}

export const Annotations = ({
  annotation,
  onAnnotationResponse,
  notesPopupDisplay,
  setNotesPopupDisplay,
  flashcardPopupDisplay,
  setFlashcardPopupDisplay,
  showAnnotationMenu,
  hideAnnotationMenu,
  annotationsPopoverData,
  showAnnotationsPopover,
  hideAnnotationsPopover,
  setCurrentAnnotation,
  renderer,
}: IAnnotations): ReactElement => {
  const toggleNotesPopup = (visibility: boolean): void => {
    hideAnnotationMenu();
    setNotesPopupDisplay(visibility);
  };

  const toggleFlashcardPopup = (visibility: boolean): void => {
    hideAnnotationMenu();
    setFlashcardPopupDisplay(visibility);
  };

  const saveAnnotation = (annotation: IAnnotation): void => {
    annotation = {
      ...annotation,
      annotationId: annotation.annotationId || getUniqueIdForAnnotation(),
    };
    onAnnotationResponse(annotation);
  };

  return (
    <Fragment>
      {showAnnotationMenu && (
        <AnnotationContextMenu
          annotation={annotation}
          onAnnotationResponse={saveAnnotation}
          toggleNotesPopup={toggleNotesPopup}
          toggleFlashcardPopup={toggleFlashcardPopup}
          hideAnnotationMenu={hideAnnotationMenu}
          renderer={renderer}
        />
      )}
      {notesPopupDisplay && (
        <NotesPopup
          annotation={annotation}
          onAnnotationResponse={saveAnnotation}
          toggleNotesPopup={toggleNotesPopup}
        />
      )}
      {showAnnotationsPopover && (
        <AnnotationsPopover
          annotationsPopoverData={annotationsPopoverData}
          hideAnnotationsPopover={hideAnnotationsPopover}
          setCurrentAnnotation={setCurrentAnnotation}
          toggleNotesPopup={toggleNotesPopup}
          toggleFlashcardPopup={toggleFlashcardPopup}
        />
      )}

      {flashcardPopupDisplay && (
        <FlashcardPopup
          annotation={annotation}
          onAnnotationResponse={saveAnnotation}
          toggleFlashcardPopup={toggleFlashcardPopup}
        />
      )}
    </Fragment>
  );
};
